export default __webpack_public_path__ + "static/media/deposit-qrcode-step2.8b34ed34.png";